import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import UpgradePlanButton from '../../../UpgradePlanButton';

const excludeFeaturesUpgradeButton = [
  'download-file-with-metadata',
  'public-file-urls',
  'share-templates',
  'file-status',
];

const SettingsItemTitle = ({ setting }) => {
  const intl = useIntl();

  return (
    <div className="switch-details">
      {setting.name && (
        <div className="workspace-settings-name-wrapper">
          <h4>
            {setting.name}
            {(
              setting.feature_name &&
              !excludeFeaturesUpgradeButton.includes(setting.feature_name)
            ) && (
              <UpgradePlanButton
                feature={setting.feature_name}
              />
            )}
          </h4>
        </div>
      )}
      {(setting.description && !setting.description_hidden) && (
        <p>
          {setting.description}
          {setting.learn_more && (
            <>
              {' '}
              <a href={setting.learn_more} target="_blank" rel="noreferrer">
                {intl.formatMessage({ defaultMessage: 'Learn more' })}
              </a>
            </>
          )}
        </p>
      )}
    </div>
  );
};

SettingsItemTitle.propTypes = {
  setting: PropTypes.object.isRequired,
};

export default SettingsItemTitle;
